import React from 'react';
import { useUnit } from 'effector-react';
import { useLocation } from 'react-router-dom';
import { $catalogProducts } from 'domains/catalog';
import { ProductHeading } from '../ui-kit/components/ProductHeading';

const decodeSlug = (pathname: string): string | null => {
  try {
    return decodeURIComponent(pathname.replace(/^\/+|\/+$/g, '')) || null;
  } catch {
    return null;
  }
};

export const ProductRouteHeading = () => {
  const { pathname } = useLocation();
  const products = useUnit($catalogProducts);
  const [clientMounted, setClientMounted] = React.useState(false);

  React.useEffect(() => setClientMounted(true), []);

  if (clientMounted || !products) return null;

  const slug = decodeSlug(pathname);
  const product = slug
    ? [...products.dishes, ...products.constructors]
      .find(({ linkValue }) => linkValue?.value === slug)
    : null;

  return product
    ? <ProductHeading className='title'>{product.name}</ProductHeading>
    : null;
};
